import Close from "../../../assets/images/icons/close.svg";
import { Images } from "../../Common/Images";
import CustomSearchableDropdown from "../../Common/CustomSearchableDropdown";
import { getLocalDateString, getWeekKeyFromDate } from "./calendarMonthUtils";

const GuestModal = ({ onClose, context }) => {
    const {
        t,
        clickedFullDay,
        weekData,
        bookingSpotData,
        guestErrors,
        guestName,
        setGuestName,
        guestLastName,
        setGuestLastName,
        guestEmail,
        setGuestEmail,
        identificatoin,
        setIdentification,
        selectedGuestVehicleNumber,
        setSelectedGuestVehicleNumber,
        selectedGuestVehicleType,
        setSelectedGuestVehicleType,
        selectedGuestFuelType,
        setSelectedGuestFuelType,
        selectedGuestAccessibleType,
        setSelectedGuestAccessibleType,
        selectedGuestShareableType,
        setSelectedGuestShareableType,
        clearGuestFieldError,
        pendingGuestBooking,
        executeRandomSpaceBooking,
        validateGuestFields,
        resetForm,
        setshowGuestPopupFullday,
        setGuestErrors,
    } = context;

    const bookingDate = clickedFullDay;
    const weekKey = bookingDate ? getWeekKeyFromDate(bookingDate) : null;
    const bookingDateStr = getLocalDateString(bookingDate);

    const bookingForModal =
        (weekKey && weekData?.[weekKey]?.find(
            (booking) => booking.BookingDate === bookingDateStr
        )) ||
        bookingSpotData.find(
            (booking) => booking.BookingDate === bookingDateStr
        );

    const GuestVehicleTypes = bookingForModal?.GuestVehicleTypes || bookingForModal?.GuestVehicleType || [];
    const GuestFuelTypes = bookingForModal?.GuestFuelTypes || [];
    const GuestShareableTypes = bookingForModal?.GuestShareableTypes || [];
    const GuestAccessibleTypes = bookingForModal?.GuestAccessibleTypes || [];
    const guestShareableOptions = [{ Id: 0, Name: "--" }, ...GuestShareableTypes];
    const guestAccessibleOptions = [{ Id: 0, Name: "--" }, ...GuestAccessibleTypes];

    return (
        <div>
            <div
                className="modal ctm-modalscroll-modal"
                style={{ display: "block", backgroundColor: "rgba(217, 217, 217, 0.59)" }}
                id="dateModal"
                data-bs-backdrop="static"
                data-bs-keyboard="false"
                tabIndex="-1"
                aria-labelledby="dateModalLabel"
                aria-hidden="true"
            >
                <div className="modal-dialog modal-dialog-centered modal-custom-width">
                    <div className="modal-content modal-radius">
                        <div className="modal-body">
                            <div className="ctm-modal-header">
                                <div className="close-modal">
                                    <a>
                                        <img src={Close} alt="Close" onClick={resetForm} />
                                    </a>
                                </div>
                                <div className="pt-2">
                                    <h5 className="popup-title">{t("react_guest_details")}</h5>
                                </div>
                            </div>
                            <div className="modal-des">
                                <div className="modal-scroll-inner">
                                    <div>
                                        <form>
                                            <div className="form-row mb-3">
                                                <label className="popup-inner-title m-0">{t("firstName")}*</label>
                                                <input
                                                    type="text"
                                                    placeholder={`${t("firstName")}*`}
                                                    className={`form-control ${guestErrors.fullDay.firstname ? "error-form" : ""} ${!guestErrors.fullDay.firstname && guestName ? "success-validation" : ""}`}
                                                    value={guestName}
                                                    onChange={(e) => {
                                                        setGuestName(e.target.value);
                                                        clearGuestFieldError("fullDay", "firstname");
                                                    }}
                                                />
                                                {guestErrors.fullDay.firstname && (
                                                    <div className="error-text"><img src={Images.ErrorMsg} alt="" /> <p>{guestErrors.fullDay.firstname}</p></div>
                                                )}
                                            </div>

                                            <div className="form-row mb-3">
                                                <label className="popup-inner-title m-0">{t("lastName")}*</label>
                                                <input
                                                    type="text"
                                                    placeholder={`${t("lastName")}*`}
                                                    className={`form-control ${guestErrors.fullDay.lastname ? "error-form" : ""} ${!guestErrors.fullDay.lastname && guestLastName ? "success-validation" : ""}`}
                                                    value={guestLastName}
                                                    onChange={(e) => {
                                                        setGuestLastName(e.target.value);
                                                        clearGuestFieldError("fullDay", "lastname");
                                                    }}
                                                />
                                                {guestErrors.fullDay.lastname && (
                                                    <div className="error-text"><img src={Images.ErrorMsg} alt="" /> <p>{guestErrors.fullDay.lastname}</p></div>
                                                )}
                                            </div>

                                            <div className="form-row mb-3">
                                                <label className="popup-inner-title m-0">{t("email_address")}*</label>
                                                <div className="position-relative">
                                                <input
                                                    type="email"
                                                    placeholder="___@____"
                                                    className={`form-control ${guestErrors.fullDay.email ? "error-form" : ""} ${!guestErrors.fullDay.email && guestEmail ? "success-validation" : ""}`}
                                                    value={guestEmail}
                                                    onChange={(e) => {
                                                        setGuestEmail(e.target.value);
                                                        clearGuestFieldError("fullDay", "email");
                                                    }}
                                                />
                                                <img
                                                    src={Images.EmailMessage}
                                                    alt=""
                                                    // Hidden while the input shows its own right-side icon - the red error icon
                                                    // (error-form) or the green success tick (success-validation) - so they don't overlap
                                                    className={`form-icon ${guestErrors.fullDay.email || guestEmail ? "d-none" : ""}`}
                                                />
                                                {guestErrors.fullDay.email && (
                                                    <div className="error-text"><img src={Images.ErrorMsg} alt="" /> <p>{guestErrors.fullDay.email}</p></div>
                                                )}
                                                </div>
                                            </div>

                                            <div className="form-row mb-3">
                                                <label className="popup-inner-title m-0">{t("react_national_id_optional")}</label>
                                                <input
                                                    type="text"
                                                    placeholder={`${t("react_national_id_optional")}`}
                                                    className="form-control"
                                                    value={identificatoin}
                                                    onChange={(e) => setIdentification(e.target.value)}
                                                />
                                            </div>

                                            {GuestVehicleTypes.length > 0 && (
                                                <div className="form-row mb-3">
                                                    <label className="popup-inner-title m-0">{t("vehicle_registration_number")}</label>
                                                    <input
                                                        type="text"
                                                        placeholder={`${t("vehicle_plate_placeholder")}`}
                                                        className="form-control"
                                                        value={selectedGuestVehicleNumber}
                                                        onChange={(e) => setSelectedGuestVehicleNumber(e.target.value)}
                                                    />
                                                </div>
                                            )}

                                            {GuestVehicleTypes.length > 0 && (
                                                <div className="form-row mb-3">
                                                    <label className="popup-inner-title m-0">{t("react_vehicle_size")}</label>
                                                    <div className="custom-dropdown modal-dropdown mb-3" style={{ position: "relative" }}>
                                                        <CustomSearchableDropdown
                                                            items={GuestVehicleTypes}
                                                            value={selectedGuestVehicleType?.Id ?? GuestVehicleTypes[0]?.Id ?? ""}
                                                            labelKey="Name"
                                                            valueKey="Id"
                                                            searchable={false}
                                                            placeholder={`${t("react_national_id_optional")}`}
                                                            disabled={!GuestVehicleTypes.length}
                                                            onChange={(value) => {
                                                                const vehicleType = GuestVehicleTypes.find((v) => String(v.Id) === String(value)) || null;
                                                                setSelectedGuestVehicleType(vehicleType);
                                                            }}
                                                        />
                                                    </div>
                                                </div>
                                            )}

                                            {GuestFuelTypes.length > 0 && (
                                                <div className="form-row mb-3">
                                                    <label className="popup-inner-title m-0">{t("fuel")}</label>
                                                    <div className="custom-dropdown modal-dropdown mb-3" style={{ position: "relative" }}>
                                                        <CustomSearchableDropdown
                                                            items={GuestFuelTypes}
                                                            value={selectedGuestFuelType?.Id ?? GuestFuelTypes[0]?.Id ?? ""}
                                                            labelKey="Name"
                                                            valueKey="Id"
                                                            searchable={false}
                                                            placeholder={`${t("fuel")}`}
                                                            disabled={!GuestFuelTypes.length}
                                                            onChange={(value) => {
                                                                const fuelType = GuestFuelTypes.find((f) => String(f.Id) === String(value)) || null;
                                                                setSelectedGuestFuelType(fuelType);
                                                            }}
                                                        />
                                                    </div>
                                                </div>
                                            )}

                                            {GuestAccessibleTypes.length > 0 && (
                                                <div className="form-row mb-3">
                                                    <label className="popup-inner-title m-0">{t("VehicleTypeReducedMobility")}</label>
                                                    <div className="custom-dropdown modal-dropdown mb-3" style={{ position: "relative" }}>
                                                        <CustomSearchableDropdown
                                                            items={guestAccessibleOptions}
                                                            value={selectedGuestAccessibleType?.Id ?? 0}
                                                            labelKey="Name"
                                                            valueKey="Id"
                                                            searchable={false}
                                                            placeholder={`${t("VehicleTypeReducedMobility")}`}
                                                            disabled={!guestAccessibleOptions.length}
                                                            onChange={(value) => {
                                                                const accessibleType = guestAccessibleOptions.find((item) => String(item.Id) === String(value)) || null;
                                                                setSelectedGuestAccessibleType(accessibleType);
                                                            }}
                                                        />
                                                    </div>
                                                </div>
                                            )}

                                            {GuestShareableTypes.length > 0 && (
                                                <div className="form-row mb-3">
                                                    <label className="popup-inner-title m-0">{t("label_shareable_category")}</label>
                                                    <div className="custom-dropdown modal-dropdown mb-3" style={{ position: "relative" }}>
                                                        <CustomSearchableDropdown
                                                            items={guestShareableOptions}
                                                            value={selectedGuestShareableType?.Id ?? 0}
                                                            labelKey="Name"
                                                            valueKey="Id"
                                                            searchable={false}
                                                            placeholder={`${t("label_shareable_category")}`}
                                                            disabled={!guestShareableOptions.length}
                                                            onChange={(value) => {
                                                                const shareableType = guestShareableOptions.find((item) => String(item.Id) === String(value)) || null;
                                                                setSelectedGuestShareableType(shareableType);
                                                            }}
                                                        />
                                                    </div>
                                                </div>
                                            )}
                                        </form>
                                    </div>
                                </div>
                            </div>
                            <div className="tags-btn ctm-modal-footer">
                                <button
                                    type="submit"
                                    className="w-100 min-height-56 selected"
                                    onClick={async (e) => {
                                        e.preventDefault();
                                        const isValid = validateGuestFields(
                                            {
                                                name: guestName,
                                                surname: guestLastName,
                                                email: guestEmail
                                            },
                                            "fullDay"
                                        );

                                        if (!isValid) {
                                            return;
                                        }
                                        onClose();
                                        if (!pendingGuestBooking) return;

                                        await executeRandomSpaceBooking(
                                            pendingGuestBooking.zoneId,
                                            pendingGuestBooking.bookingDateStr,
                                            selectedGuestVehicleType?.Id ?? pendingGuestBooking.VehicleTypeId,
                                            selectedGuestFuelType?.Id ?? pendingGuestBooking.fuelId,
                                            selectedGuestShareableType?.Id ?? pendingGuestBooking.vehicleShareableId,
                                            selectedGuestAccessibleType?.Id ?? pendingGuestBooking.vehicleAccessibleId,
                                            pendingGuestBooking.vehicleRegistrationId,
                                            pendingGuestBooking.isGuestFlag,
                                            {
                                                guestName,
                                                guestLastName,
                                                guestEmail,
                                                guestIdentification: identificatoin,
                                                guestVehicleNumber: selectedGuestVehicleNumber,
                                                spotName: pendingGuestBooking.spotName,
                                                startTime: pendingGuestBooking.startTime,
                                                endTime: pendingGuestBooking.endTime
                                            }
                                        );

                                        resetForm();
                                    }}
                                >
                                    {t("confirm")}
                                </button>

                                <button
                                    type="button"
                                    className="main-btn outline-gray-btn w-100 mw-100 min-height-56"
                                    onClick={() => {
                                        setshowGuestPopupFullday(false);
                                        setGuestErrors((prev) => ({
                                            ...prev,
                                            fullDay: {
                                                firstname: "",
                                                lastname: "",
                                                email: ""
                                            }
                                        }));
                                    }}
                                >
                                    {t("cancel")}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default GuestModal;
